import React from 'react';

const SearchZoomInIcon = (svg: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...svg}
    className="stroke-[#26272B] transition-all duration-300 group-hover:stroke-primary-500"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.19995 11.7002H14.2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.7 14.2002V9.2002" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M22 22L20 20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default SearchZoomInIcon;
